<template>
    <div class="dashboard">
        <h1>Client Dashboard</h1>
        <p>This is the dashboard view for Client. Yupiii!</p>        
    </div>
</template>
<script>
</script>